import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResellerAccountState } from './reseller-account-state';
import { Box, Grid, InputAdornment, Skeleton } from '@mui/material';
import CardView from '../../component/card/card-view';
import { useManualRemove } from '../mobx-objs/mobx-manager';
import CardFrom, { CardFormConfig } from '../../component/card/card-from';
import DeleteDialogComponent from '../../component/dialog/delete-dialog.component';
import ButtonComponent from '../../component/button/button.component';
import i18n from '../../i18n';
import { Group, Restaurant, Warrant } from '../../models';
import moment from 'moment';
import './scss/reseller-account.style.scss';
import _ from 'lodash';
import LockResetIcon from '@mui/icons-material/LockReset';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import EditIcon from '@mui/icons-material/Edit';
import UpdateBalance from './updata-balance';
import { dateFormat } from '../../constants/utils';
import { getAuthPointI18n } from '../../constants/tool-auth-point';
import { AuthPointDialog } from '../group/authorization-manager/auth-point-dialog';
import { TableRowFeatures } from '../../component/table/table.component';
import { CloseSharp } from '@mui/icons-material';

// 卡片组渲染数据
export const ResellerAccountCardArr: CardFormConfig[] = [
    // 主要信息数据
    {
        key: 'main',
        title: 'create_group_component_text_main_information',
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        children: [
            {
                comType: 'AVATAR',
                key: 'avatar',
                xs: 12,
            },
            {
                key: 'first_name',
                label: i18n.t('person_page_text_name'),
                required: true,
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 6,
                md: 6,
            },
            {
                key: 'last_name',
                label: i18n.t('person_page_text_surname'),
                required: true,
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 6,
                md: 6,
            },
            {
                key: 'gender',
                label: i18n.t('general_text_gender'),
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 6,
                md: 6,
            },
            {
                key: 'birth',
                label: i18n.t('person_page_text_birthday'),
                required: true,
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 6,
                md: 6,
            }
        ]
    },
    // 地址信息数据
    {
        key: 'address',
        title: 'address_component_text_address',
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        children: [
            {
                key: 'local',
                label: 'address_component_text_address',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 12,
                md: 12,
            },
            {
                key: 'home_number',
                label: 'address_component_text_doorbell',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 4,
            },
            {
                key: 'postcode',
                label: 'address_component_text_postal_code',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 4,
            },
            {
                key: 'city',
                label: 'address_component_text_city',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 4,
            },
            {
                key: 'state',
                label: 'address_component_text_province',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6,
            },
            {
                key: 'country',
                label: 'address_component_text_country',
                inputType: 'INPUT',
                comType: 'INPUT',
                xs: 6,
                md: 6,
            },
        ]
    },
    // 余额, 折扣
    {
        key: 'money',
        title: 'reseller_page_reseller_balance',
        rowSpacing: 6,
        columnSpacing: { md: 4, xs: 4 },
        children: [
            {
                key: 'balance',
                label: 'reseller_page_reseller_balance',
                inputType: 'INPUT',
                comType: 'INPUT',
                contentType: 'number',
                regularType: 'price',
                xs: 6,
            },
            {
                key: 'reseller_discount',
                label: 'daily_business_summary_page_discount',
                inputType: 'INPUT',
                comType: 'INPUT',
                contentType: 'number',
                xs: 6,
                regularType: 'discount',
                InputProps: {
                    endAdornment: <InputAdornment position='end'>%</InputAdornment>
                },
            },
        ]
    },
    // 联系方式表单数据
    {
        key: 'contactWay',
        title: 'create_group_component_text_contact',
        rowSpacing: 5,
        columnSpacing: { md: 4 },
        children: [
            {
                key: 'phone_prefix',
                label: 'general_text_country_code',
                comType: 'INPUT',
                inputType: 'COUNTRY_SELECT',
                xs: 3,
            },
            {
                key: 'phone',
                label: 'create_group_component_text_phone',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'phone',
                xs: 9,
                required: true,
            },
            {
                key: 'password',
                label: i18n.t('login_page_text_password'),
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 12,
                md: 12,
            }
        ]
    },
    // 税务信息表单数据
    {
        key: 'tableCom',
        title: 'create_group_component_text_tax_information',
        rowSpacing: 6,
        xs: 12,
        md: 12,
        columnSpacing: { md: 4 },
        titleTypographyProps: {
            // height: 50
            paddingRight: 10
        },
        children: [
            {
                key: 'reg_name',
                label: 'restaurant_info_page_text_company',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'reg_name',
                xs: 6,
                md: 6,
            },
            {
                key: 'reg_local',
                label: 'restaurant_info_page_text_restaurant_tax_address',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'reg_local',
                xs: 6,
                md: 6,
            },
            {
                key: 'reg_city',
                label: 'address_component_text_city',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'reg_city',
                xs: 6,
                md: 6,
            },
            {
                key: 'reg_state',
                label: 'restaurant_info_page_text_state',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'reg_state',
                xs: 6,
                md: 6,
            },
            {
                key: 'reg_country',
                label: 'restaurant_info_page_text_country',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'reg_country',
                xs: 6,
                md: 6,
            },
            {
                key: 'reg_postcode',
                label: 'restaurant_info_page_text_postcode',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'reg_postcode',
                xs: 6,
                md: 6,
            },
            {
                key: 'reg_fiscal_code',
                label: 'create_group_component_text_fiscal_code',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'fiscalCode',
                xs: 6,
                md: 6,
            },
            {
                key: 'reg_vat_number',
                label: 'create_group_component_text_vat_number',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'vatNumber',
                xs: 6,
                md: 6,
            },
            {
                key: 'reg_pec',
                label: 'create_group_component_text_recipient_mailbox',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'email',
                xs: 6,
                md: 6,
            },
            {
                key: 'reg_des_code',
                label: 'create_group_component_text_electronic_invoice_recipient_code',
                inputType: 'INPUT',
                comType: 'INPUT',
                regularType: 'recipientCode',
                xs: 6,
                md: 6,
            },
        ]
    },
    // 经销商可销售的授权点
    {
        key: 'belonged_warrant',
        title: i18n.t('warrant_page_text_authorization_points'),
        rowSpacing: 6,
        xs: 12,
        md: 12,
        columnSpacing: { md: 4 },
        titleTypographyProps: {
            paddingRight: 10
        },
        children: [
            {
                key: 'belonged_warrant_table',
                comType: 'TABLE',
                xs: 12,
            }
        ]
    },
    // 关联集团
    {
        key: 'responsible_group',
        title: i18n.t('reseller_page_associate_group'),
        rowSpacing: 6,
        xs: 12,
        md: 12,
        columnSpacing: { md: 4 },
        titleTypographyProps: {
            paddingRight: 10
        },
        children: [
            {
                key: 'responsible_group_table',
                comType: 'TABLE',
                xs: 12,
            }
        ]
    },
    // 关联餐厅
    {
        key: 'responsible_restaurant',
        title: i18n.t('reseller_page_associate_restaurant'),
        rowSpacing: 6,
        xs: 12,
        md: 12,
        columnSpacing: { md: 4 },
        titleTypographyProps: {
            // height: 50
            paddingRight: 10
        },
        children: [
            {
                key: 'responsible_restaurant_table',
                comType: 'TABLE',
                xs: 12,

            }
        ]
    },

];

/**
 * 经销商账号信息详情
 */
const ResellerAccount = observer((props: AccountProps) => {
    useTranslation();

    const { componentSource } = props;
    // 数据管理
    const useMobxData = props.useResellerAccountMobx;

    // 骨架屏控制
    const [skeleton, setSkeleton] = React.useState<boolean>(true);


    React.useEffect(() => {
        initComponent();
        // 卸载
        return () => {
            // MobxObjectsManager.remove(GroupAccountState);
        }
    }, []);

    // 初始化组件
    const initComponent = async () => {
        await useMobxData.init();
        // 关闭骨架屏
        setSkeleton(false);
    }
    // unmount
    useManualRemove(ResellerAccountState);

    // 数据
    const {
        operateMap,
        originResellerData,
        isEmptyVerify,
        deleteDialogConfig,
        resellerEditDetail,
        isEditInput,
        disabledBtn,
    } = useMobxData;

    // 卡片组渲染数据
    const cardArr: CardFormConfig[] = ResellerAccountCardArr.map((parentItem) => {
        // 新增经销商、敏感操作不显示关联集团、关联餐厅
        if ((['ADD', 'SENSITIVE'].includes(componentSource)) && (['responsible_group', 'responsible_restaurant'].includes(parentItem.key))) {
            _.set(parentItem, 'hidden', true)
        } else {
            _.set(parentItem, 'hidden', false)
        }
        let extraParentConfig = {};
        switch (parentItem.key) {
            case 'money':
                extraParentConfig = {
                    actionRender: (
                        componentSource !== 'ADMIN_RESELLER_DETAIL' ? <></> :
                            <Box>
                                <ButtonComponent
                                    titleText={i18n.t('reseller_page_edit_reseller_balance')}
                                    variant='contained'
                                    space={false}
                                    children={<EditIcon />}
                                    handleClick={async () => {
                                        useMobxData.setIsOpenBalanceDialog(true);
                                    }}
                                />
                            </Box>

                    ),
                }
                break;
            case 'belonged_warrant':
                extraParentConfig = {
                    actionRender: ['ADMIN_RESELLER_DETAIL', 'ADD'].includes(componentSource) ?
                        <ButtonComponent
                            action='ADD'
                            handleClick={() => useMobxData.handleOpenAuthPoint()}
                            async={false}
                        /> : <></>
                }
                break;
            default:
                break;
        }
        return {
            ...extraParentConfig,
            ...parentItem,
            children: parentItem?.children?.map((childrenItem) => {
                let extraConfig = {};
                // 禁用输入框
                const disabledInput =
                    (componentSource === 'RESELLER_RESELLER_DETAIL' && ['balance', 'reseller_discount'].includes(childrenItem.key)) ||
                    (componentSource === 'ADMIN_RESELLER_DETAIL' && childrenItem.key === 'balance') ||
                    ['RECYCLE', 'SENSITIVE'].includes(componentSource);
                // 折扣、密码输入框隐藏：reseller端隐藏折扣
                const hidden = ['reseller_discount', 'password'].includes(childrenItem.key) && componentSource === 'RESELLER_RESELLER_DETAIL';
                switch (childrenItem.key) {
                    case 'avatar':
                        extraConfig = {
                            isDisabledUpload: !['ADMIN_RESELLER_DETAIL', 'RESELLER_RESELLER_DETAIL', 'ADD'].includes(componentSource),
                            handleChangeAvatar: ((_avatarUrl: string, file: File) => {
                                return useMobxData.onChangeAvatar(file);
                            })
                        }
                        break;
                    case 'belonged_warrant_table':
                        extraConfig = {
                            tableConfig: {
                                showChecked: 0,
                                isPagination: true,
                                rowsPerPage: 50,
                                headCellList: [
                                    {
                                        id: 'name', label: i18n.t('global_text_name'),
                                        renderFunction: (row: Warrant) => getAuthPointI18n(row?.warranti18N?.name || [])
                                    },
                                    {
                                        id: 'type', label: i18n.t('message_notify_page_type'), renderFunction: (row: Warrant) => row.code?.includes('AUC') ? i18n.t('warrant_page_text_authorization_set') : i18n.t('warrant_page_text_authorization_scheme')
                                    },
                                    { id: 'code', label: i18n.t('warrant_page_text_authorization_points') },
                                    {
                                        id: '-1', label: '', sortStatus: -1,
                                        renderFunction: (row: Warrant) => {
                                            return ['ADMIN_RESELLER_DETAIL', 'ADD'].includes(componentSource) ?
                                                <TableRowFeatures
                                                    buttons={[
                                                        {
                                                            variant: 'contained',
                                                            color: 'secondary',
                                                            titleText: i18n.t('general_text_delete'),
                                                            children: (<CloseSharp />),
                                                            handleClick: () => {
                                                                useMobxData.updateDeleteDialogConfig({
                                                                    visible: true,
                                                                    title: '',
                                                                    content: '',
                                                                    handleClick: async () => await useMobxData.handleDeleteAuthPoint(row)

                                                                });
                                                            }
                                                        }
                                                    ]} /> : <></ >
                                        }
                                    }

                                ],
                                list: useMobxData.authPointList,
                                allCount: useMobxData.authPointList.length,
                            }
                        }
                        break;
                    case 'responsible_group_table':
                        extraConfig = {
                            tableConfig: {
                                showChecked: 0,
                                isPagination: true,
                                headCellList: [
                                    {
                                        id: '1', label: i18n.t('group_management_page_text_group_name'),
                                        renderFunction: (row: Group) => {
                                            return <>{row.nickname}</>
                                        }
                                    },
                                    { id: 'string_id', label: i18n.t('group_management_page_text_group_identification_code') },
                                    {
                                        id: 'create_date', label: i18n.t('restaurant_extensions_page_text_create_time'),
                                        renderFunction: (row: any) => {
                                            return row?.create_date ? dateFormat(row?.create_date, 'HH:mm:ss DD/MM/YYYY') : '';
                                        }
                                    },

                                ],
                                list: originResellerData.responsible_group || [],
                                allCount: originResellerData.responsible_group?.length || 0,
                            }
                        }
                        break;
                    case 'responsible_restaurant_table':
                        extraConfig = {
                            tableConfig: {
                                showChecked: 0,
                                isPagination: true,
                                headCellList: [
                                    {
                                        id: '1', label: i18n.t('restaurant_management_page_table_text_restaurant_name'),
                                        renderFunction: (row: Restaurant) => {
                                            return <>{row.nickname}</>
                                        }
                                    },
                                    { id: 'string_id', label: i18n.t('restaurant_page_input_text_restaurant_identification_code') },
                                    {
                                        id: 'restaurant_belonged_group.nickname', label: i18n.t('general_text_belonged_group'),
                                    },
                                    {
                                        id: 'restaurant_belonged_group.string_id', label: i18n.t('group_management_page_text_group_identification_code'),
                                    },
                                    {
                                        id: 'create_date', label: i18n.t('restaurant_extensions_page_text_create_time'),
                                        renderFunction: (row: any) => {
                                            return row?.create_date ? dateFormat(row?.create_date, 'HH:mm:ss DD/MM/YYYY') : '';
                                        }
                                    },
                                ],
                                list: originResellerData.responsible_restaurant || [],
                                allCount: originResellerData.responsible_restaurant?.length || 0,
                            }
                        }
                        break;
                    case 'gender':
                        extraConfig = {
                            items: [{
                                value: '0',
                                label: i18n.t('person_page_button_male')
                            }, {
                                value: '1',
                                label: i18n.t('person_page_button_female')
                            }],
                            onChange: (e) => {
                                useMobxData.handleChangeText(e.target.value, 'gender');
                            },
                            inputType: 'SELECT',
                            disabledInput: useMobxData.isEditInput,
                            comType: 'INPUT',
                            inputIsEdited: useMobxData.operateMap.get('gender') !== undefined ? true : false,
                            xs: 2,
                            md: 6,
                            isEmpty: useMobxData.allowNullVerification
                        }
                        break;
                    case 'birth':
                        extraConfig = {
                            handleChangePicker: (value) => {
                                const pickerValue = value ? moment(value).format(moment.HTML5_FMT.DATETIME_LOCAL_MS) : null;
                                const e = { target: { value: pickerValue ? pickerValue.toString() : null } };
                                useMobxData.handleChangeText(e.target.value || '', 'birth');
                            },
                            inputType: 'DATE',
                            disabledInput: useMobxData.isEditInput,
                            comType: 'INPUT',
                            inputIsEdited: useMobxData.operateMap.get('birth') ? true : false,
                            xs: 6,
                            md: 6,
                            isEmpty: useMobxData.allowNullVerification,
                            maxDate: new Date()
                        }
                        break;
                    case 'password':
                        extraConfig = {
                            inputIsEdited: useMobxData.operateMap.get('password') !== undefined ? true : false,
                            onChange: (e) => {
                                useMobxData.handleChangeText(e.target.value, 'password');
                            },
                            isEmpty: useMobxData.allowNullVerification,
                            subTitle: i18n.t('login_page_text_password'),
                            label: i18n.t('login_page_text_password'),
                            disabledInput: false,
                            regularType: 'password',
                            comType: 'INPUT',
                            inputType: 'INPUT',
                            hidden: false,
                            required: componentSource === 'ADD' ? true : false,
                            additionDescription: () => {
                                return componentSource !== 'ADMIN_RESELLER_DETAIL' ? <> </> :
                                    <Box marginLeft={2} sx={{ fontSize: 12, flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center', display: 'flex', }}>
                                        {
                                            originResellerData.is_edit_pass ?
                                                null
                                                :
                                                <Box display={'flex'} alignItems={'center'}>
                                                    <ErrorOutlineIcon fontSize='small' />
                                                    <span>{i18n.t('edit_account_user_had_not_change_paswword')}</span>
                                                </Box>
                                        }
                                        {/* 初始化密码按钮 */}
                                        <Box>
                                            <ButtonComponent
                                                titleText={i18n.t('ground_staff_component_text_initialize_password')}
                                                variant='contained'
                                                space={false}
                                                children={<LockResetIcon />}
                                                handleClick={async () => {
                                                    await useMobxData.initializePassword();
                                                }}
                                                disabled={disabledInput || isEditInput}
                                            />
                                        </Box>
                                    </Box>
                            }
                        }
                        break;
                    default:
                        break;
                }
                return {
                    ...childrenItem,
                    ...extraConfig,
                    // 非空校验
                    isEmpty: isEmptyVerify,
                    // 编辑禁用
                    disabledInput: disabledInput || isEditInput,
                    hidden: hidden,
                    // 编辑反馈
                    inputIsEdited: operateMap.get(childrenItem.key) !== undefined ? true : false,
                    onChange: (e) => {
                        return useMobxData.handleChangeText(e.target.value, childrenItem.key);
                    },
                    handleChangeCountry: (value) => {
                        return useMobxData.handleChangeText(value, 'phone_prefix');
                    }
                }
            })
        }
    }) as CardFormConfig[];

    // 渲染按钮组
    const renderActionBtn = () => {
        return (
            <Box className='top-button-reseller'>
                <ButtonComponent
                    size='small'
                    variant={'contained'}
                    forbidConfirm={disabledBtn}
                    // extraButtonStyle={'button-group'}
                    extraTitleStyle={'button-icon'}
                    titleText={`${i18n.t('general_text_save')}`}
                    action={'SAVE'}
                    handleClick={async () => {
                        // 检查必填项
                        // if (checkNeedInfo()) return;
                        await useMobxData.onSave('EDIT');
                    }}
                />
            </Box>
        )
    }


    return <Box className={'reseller-account-page '}>
        {/* 骨架屏,排除资源回收站跳转 */}
        {
            skeleton ? (
                <SkeletonViewComp />
            ) : (
                <Box className={'contain'}>
                    {
                        // 新增和预览不显示保存按钮
                        !['ADMIN_RESELLER_DETAIL', 'RESELLER_RESELLER_DETAIL'].includes(componentSource) ? null
                            :
                            renderActionBtn()
                    }

                    {/* 卡片grid布局视图 */}
                    <CardFrom
                        config={cardArr}
                        data={resellerEditDetail as {} || {}}
                    />
                </Box>
            )
        }
        {/* 是否删除所选择项目 */}
        <DeleteDialogComponent
            {...{
                title: deleteDialogConfig.title,
                open: deleteDialogConfig.visible,
                onCancel: () => {
                    useMobxData.updateDeleteDialogConfig({
                        visible: false,
                        title: '',
                        content: '',
                    });
                },
                // 确认删除
                onConfirm: () => deleteDialogConfig?.handleClick?.(),
            }}
        />

        <UpdateBalance
            isOpen={useMobxData.isOpenEditBalance}
            onClose={() => { useMobxData.setIsOpenBalanceDialog(false) }}
            originBalance={useMobxData.resellerEditDetail.balance || 0}
            isUpdating={true}
            balance={useMobxData.balance}
            onChange={(val) => {
                useMobxData.setBalance(val)
            }}
            onSave={(type: string) => {
                useMobxData.onSaveBalance(type, useMobxData.balance)
            }}
        />

        <AuthPointDialog
            open={useMobxData.authPointDialog.visible}
            onCancel={() => useMobxData.handleCloseAuthPoint()}
            operations={{ stringId: '', target: 'RESTAURANT' }}
            onClick={(selectAuth) => useMobxData.handleCheckAuthPoint(selectAuth)}
            selectedWarrant={useMobxData.authPointDialog.selectedList}
            showSelectBox={true}
            onSave={() => useMobxData.handleSaveAuthPoint()}
        />
    </Box>
})

export default ResellerAccount;

type AccountProps = {
    // 经销商_id
    belongedResellerId?: string;
    // 数据管理
    useResellerAccountMobx: ResellerAccountState;
    // 组件来源: 新增经销商、admin端经销商详情、reseller端经销商详情、资源回收站经销商详情、敏感操作编辑经销商详情（操作时的经销商详情，不需要调api）
    componentSource: 'ADD' | 'ADMIN_RESELLER_DETAIL' | 'RESELLER_RESELLER_DETAIL' | 'RECYCLE' | 'SENSITIVE';
}


function SkeletonViewComp(): JSX.Element {
    return (
        <Box className='skeleton'>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={140} height={140} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={170} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}